import { useContext, useState } from "react";
import Campo from "../Campo";
import styles from "./styles.module.css";
import VerificaForm from "../../controllers/VerificaForm";
import { UserContext } from "../../context/UserContext";
import postEdital from "../../services/postEdital";

type Props = {
  closeModal: Function;
  atualizaListaEditais: Function;
};

const AddColaboracao = ({ closeModal, atualizaListaEditais } : Props) => {
  const [titulo, setTitulo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [link, setLink] = useState("");
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const { token } = useContext(UserContext);

  const salvarDados = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const adicionarEdital = async () => {
      try {
        const novoEdital = await postEdital(token, titulo, descricao, link, dataInicio, dataFim);
        atualizaListaEditais(novoEdital);
      } catch (err) {
        console.log("Erro ao criar Colaboração", err);
      }
    };
    if (VerificaForm(e.currentTarget.form)) {
      adicionarEdital();
      closeModal();
    }
  }; 


  return (
    <form className={styles.formModal} onSubmit={salvarDados}>
      <h2>Criar um Edital de Colaboração</h2>
      <Campo
        title="Titulo"
        placeholder="Escreva o Titulo da Colaboração"
        type="text"
        customValidity="Preencha com o Titulo da Colaboração"
        value={titulo}
        setter={setTitulo}
        required
      />
      <Campo
        title="Descrição"
        placeholder="Escreva a Descrição da sua Colaboração"
        type="text"
        customValidity="Preencha com a Descrição da sua Colaboração"
        value={descricao}
        setter={setDescricao}
        required
      />
      <Campo
        title="Link PDF"
        placeholder="Coloque o link do Edital"
        type="text"
        customValidity="Preencha com o link do Edital"
        value={link}
        setter={setLink}
        required
      />
      <div className={styles.gridCampos}>
        <Campo
          title="Inicio do periodo"
          type="date"
          customValidity="Preencha com a data de Inicio do periodo de Colaboração"
          value={dataInicio}
          setter={setDataInicio}
          required
        />
        <Campo
          title="Fim do periodo"
          type="date"
          customValidity="Preencha com a data de Fim do periodo de Colaboração"
          value={dataFim}
          setter={setDataFim}
          required
        />
      </div>
      <hr className={styles.separador} />
      <input type="submit" value="+ Colaboração" />
    </form>
  );
};

export default AddColaboracao;
